module.exports = __webpack_public_path__ + "img/search-via-cv-desktop.90e6db6.svg";